import type { StarRating } from '../types/components/ldjson'

export function useStructuredData(name: string, image: string, startDate: string, endDate: string, type?: string) {
  const config = useRuntimeConfig()
  const route = useRoute()

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': type || 'Event',
    'name': name,
    'image': image,
    'startDate': startDate,
    'endDate': endDate,
    'eventAttendanceMode': 'https://schema.org/OnlineEventAttendanceMode',
    'location': {
      '@type': 'VirtualLocation',
      'url': `${config.public.host}${route.path}`,
    },
  }
  return {
    structuredData,
  }
}

export function useStarRating(data: StarRating) {
  const config = useRuntimeConfig()

  const starRating = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    'name': config.public.siteName,
    'aggregateRating': {
      '@type': 'AggregateRating',
    },
  }

  data.items.forEach((item: { key: string; value: string }) => {
    starRating.aggregateRating[item.key as keyof typeof starRating.aggregateRating] = item.value
  })
  return starRating
}
